<template>
  <v-container>
    <v-card>
      <v-card-title>News Importer</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="newsUrl"
          label="News Site URL"
          placeholder="https://www.therundown.ai/p/the-u-s-rolls-out-blueprint-for-ai-supremacy"
          outlined
          @keydown.enter="importNews"
        ></v-text-field>
        <v-btn @click="importNews" :loading="loading" :disabled="!newsUrl">Import News</v-btn>
      </v-card-text>
    </v-card>

    <v-card class="mt-4" v-if="articles.length > 0">
        <v-card-title>Imported Articles</v-card-title>
        <v-list>
            <v-list-item v-for="(article, index) in articles" :key="index">
                <v-list-item-content>
                    <v-list-item-title>{{ article.title }}</v-list-item-title>
                    <v-list-item-subtitle>{{ article.summary }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>

  </v-container>
</template>

<script>
import { getFunctions, httpsCallable } from 'firebase/functions';

export default {
  name: 'News',
  data() {
    return {
      newsUrl: '',
      loading: false,
      articles: [],
    };
  },
  methods: {
    async importNews() {
      if (!this.newsUrl) return;
      this.loading = true;
      this.articles = [];

      try {
        const functions = getFunctions();
        const processNewsUrl = httpsCallable(functions, 'processNewsUrl');
        const result = await processNewsUrl({ url: this.newsUrl });
        
        if (result.data.success) {
            this.articles = result.data.articles;
            console.log('News imported successfully:', this.articles);
        } else {
            console.error('Failed to import news.');
        }

      } catch (error) {
        console.error('Error importing news:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">

</style>